import type {CopilotAnimationStateProps} from '../types'

interface SpriteProps extends Pick<CopilotAnimationStateProps, 'state'> {
  /** CSS module class that defines the sprite dimensions and animation keyframes. */
  className: string
  /** URL of the static SVG sprite sheet, applied as a CSS mask. */
  sprite: string
}

/**
 * Renders a single-color animation sprite sheet as a CSS-masked element. The sprite SVG is loaded
 * as a static asset (keeping it out of the JS bundle) and tinted via `background-color`, so theming
 * with `currentColor` and the CSS scroll animation behave exactly as an inline `currentColor` SVG.
 */
export default function Sprite({state, className, sprite}: SpriteProps) {
  return (
    <div
      className={className}
      data-animation-state={state}
      aria-hidden="true"
      style={{'--copilot-animation-sprite': `url("${sprite}")`}}
    />
  )
}
